<template>
  <div class="bg_white">
      <van-nav-bar
      title="身份证实名认证"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      >
      <template #right>
          <van-icon name="wap-home-o" size="20"/>
      </template>
      </van-nav-bar>

      <div>

        <van-cell-group title="用户绑定后不可修改，请谨慎填写">
          <van-field
            readonly
            clickable
            label="证件类型"
            :value="idType"
            placeholder="选择证件类型"
            @click="showPicker = true"
            :disabled="ifBind"
            right-icon="arrow"
          />
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker
              show-toolbar
              :columns="typelist"
              @cancel="showPicker = false"
              @confirm="onConfirm"
              value-key="dictLabel"
            />
          </van-popup>
          <van-field v-model="param.idCardNo" :disabled="ifBind" label="证件号码" placeholder="请输入证件号码" />
        </van-cell-group>

        <div class="sub_btn m40">
              <div class="pd16">
                  <van-button :disabled="ifBind" class="btn_bg" round block type="default" size="medium" @click="onSubmit">提交绑定</van-button>
              </div>    
        </div>
      </div>

  </div>
</template>

<script>
import { getDictData,bindIdCard,ifBindIdCard } from '../../api/custom'; 

export default {
data() {
  return {
      param:{
        idCardNo:'',
        idCardType:1, 
      },
      idType:'身份证',
      showPicker:false,
      typelist:['身份证','军官证','护照','其他'],
      ifBind:false
      
  }

 },
 mounted(){
  this.checkBind()
  this.getIdType()
 },
 methods: {
  checkBind(){
    let that=this
    ifBindIdCard().then(res=>{
      if(!res.success){
        this.param.idCardNo=res.data.cardNo
        this.ifBind=true
        that.$dialog.alert({
                    message: res.message,
                    theme: 'round-button',
                    confirmButtonText:'确定'
          }).then(() => {
            
            // that.$router.back()
          });
      }
    })
  },
  getIdType(){
    getDictData("sys_id_type").then(res=>{
      this.typelist=res.data.list
    })
  },
  onSubmit(){
    //校验身份证号码是否正确
    // if(!this.IdentityCodeValid(this.param.idCardNo)){
    //     return
    // }
    
    if(this.param.idCardType==1 && this.param.idCardNo.length!=18){
      this.$dialog.alert({
                  message: "请输入正确的身份证",
                  theme: 'round-button',
                  confirmButtonText:'确定'
                })

      return false
    }
    let that =this
    bindIdCard(this.param).then(res=>{
      if(res.success){
        this.$toast({
          type:'success',
          message:'绑定成功',
          onClose:function(){
            that.$router.back()
          }
        })
      }else{
        this.$dialog.alert({
                    message: res.message,
                    theme: 'round-button',
                    confirmButtonText:'确定'
         }).then(()=>{
          console.log(res.message)
            // that.$router.push("/upload")
         })
      }
    })
  },
  onConfirm(value, index){
      console.log(`当前值：${value}, 当前索引：${index}`)
      this.idType=this.typelist[index].dictLabel
      this.param.idCardType = this.typelist[index].dictValue
      this.showPicker=false
  },
  onClickLeft() {
    this.$router.back()
  },
  onClickRight() {
    this.$router.push("/online")
  },
  IdentityCodeValid(code) { 
      let city={11:"北京",12:"天津",13:"河北",14:"山西",15:"内蒙古",21:"辽宁",22:"吉林",23:"黑龙江 ",31:"上海",32:"江苏",33:"浙江",34:"安徽",35:"福建",36:"江西",37:"山东",41:"河南",42:"湖北 ",43:"湖南",44:"广东",45:"广西",46:"海南",50:"重庆",51:"四川",52:"贵州",53:"云南",54:"西藏 ",61:"陕西",62:"甘肃",63:"青海",64:"宁夏",65:"新疆",71:"台湾",81:"香港",82:"澳门",91:"国外 "};
      let tip = "";
      let pass= true;
          //验证身份证格式（6个地区编码，8位出生日期，3位顺序号，1位校验位）
          if(!code || !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)){
              tip = "身份证号格式错误";
              pass = false;
          }
          
         else if(!city[code.substr(0,2)]){
              tip = "地址编码错误";
              pass = false;
          }
          else{
              //18位身份证需要验证最后一位校验位
              if(code.length == 18){
                  code = code.split('');
                  //∑(ai×Wi)(mod 11)
                  //加权因子
                  var factor = [ 7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2 ];
                  //校验位
                  var parity = [ 1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2 ];
                  var sum = 0;
                  var ai = 0;
                  var wi = 0;
                  for (var i = 0; i < 17; i++)
                  {
                      ai = code[i];
                      wi = factor[i];
                      sum += ai * wi;
                  }
                  //var last = parity[sum % 11];
                  if(parity[sum % 11] != code[17]){
                      tip = "校验位错误";
                      pass =false;
                  }
              }
          }
          if(!pass) this.$dialog.alert({
                  message: tip,
                  theme: 'round-button',
                  confirmButtonText:'确定'
              });
          return pass;
      }
}

};
</script>

<style lang="less">



</style>